import request from '@/plugins/axios'

export const getLogs = (params) => request({
  method: 'get',
  url: 'call-log',
  params
})
